// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2UV6D","amount":"Amount_amount__GapM0","tip":"Amount_tip__3zuQE","tipHeader":"Amount_tipHeader__3oWYV","tipsWrap":"Amount_tipsWrap__3lo2g"};